/**
 * Calendar-tab composition-root wiring for Student/Staff detail (11E.7).
 *
 * `EntityCalendarTab` (features/calendar) is router-agnostic — it takes an
 * `onOpenSession` callback rather than calling `useNavigate` itself — so
 * these thin wrappers exist purely to supply that callback. Same reasoning
 * as `bookingPickers.tsx` / `sessionRegister.tsx`: only the composition
 * root may import both `features/people`'s detail pages and
 * `features/calendar`, and keeping these in their own file (rather than
 * `routes/index.tsx`) keeps that file's Fast Refresh boundary clean — a
 * file that also exports the non-component `routes` array cannot be a
 * component-only module.
 */

import { useNavigate } from 'react-router-dom';

import { EntityCalendarTab, type SessionResponse } from '@/features/calendar';

export function StudentCalendarTab({ studentId }: { studentId: string }) {
  const navigate = useNavigate();
  return (
    <EntityCalendarTab
      studentId={studentId}
      onOpenSession={(s: SessionResponse) => navigate(`/sessions/${s.id}`)}
    />
  );
}

export function StaffCalendarTab({ staffId }: { staffId: string }) {
  const navigate = useNavigate();
  return (
    <EntityCalendarTab
      teacherId={staffId}
      onOpenSession={(s: SessionResponse) => navigate(`/sessions/${s.id}`)}
    />
  );
}
